import { pathMatchesNavPath } from '@/shared/utils/navPathMatch'
import { flattenNavData, getNavData } from '@/widgets/sidebar/navData'

import type { Subjects } from '../lib'

export function resolveSubjectForPathname(pathname: string): Subjects | null {
  const items = flattenNavData(getNavData())
  const sorted = items.sort(
    (a, b) => (b.path?.length ?? 0) - (a.path?.length ?? 0),
  )
  for (const item of sorted) {
    if (item.path && pathMatchesNavPath(pathname, item.path)) {
      return item.key as Subjects
    }
  }
  return null
}
